export default {
  isShown: (state) => state.isShown,
  providerId: (state) => state.providerId,
  providers: (state) => state.providers,
  loading: (state) => state.loading,
  isOurPanel: (state) => state.isOurPanel,
  providerName: (state) => state.formData.name,
  providerEndPoint: (state) => state.formData.endpoint,
  providerApiToken: (state) => state.formData.apiToken,
  providerCurrency: (state) => state.formData.currency,
  syncServices: (state) => state.formData.syncServices,
  syncPackages: (state) => state.formData.syncPackages,
  resaleMarginPercent: (state) => state.formData.resaleMarginPercent,
  syncPrices: (state) => state.formData.syncPrices,
  syncParams: (state) => state.formData.syncParams,
  syncLabels: (state) => state.formData.syncLabels,
  syncName: (state) => state.formData.syncName,
  syncMeta: (state) => state.formData.syncMeta,
  syncServiceDetails: (state) => state.formData.syncServiceDetails,
  syncDescriptionField: (state) => state.formData.syncDescriptionField,
  isArchived: (state) => state.formData.isArchived,
  autoRecreateOrdersIsAllowed: (state) => state.formData.autoRecreateOrdersIsAllowed,
  errors: (state) => state.errors,
  errorsMessage: (state) => state.errorsMessage,
};
